export default __webpack_public_path__ + "static/media/Meal-PreApp.709c27b3.png";